module.exports = __webpack_public_path__ + "static/media/resourcesNewMessageBtn.de16d6a0.png";